/**
 * Chain selection derived from VITE_BASE_CHAIN_ID.
 * 84532 → baseSepolia, 8453 → base. Anything else throws.
 * USDC address is derived from the shared canonical file.
 */
import { base, baseSepolia } from "viem/chains";
import type { Chain } from "viem";
import networksJson from "@shared/base-networks.json";

const NETWORKS = networksJson as Record<string, { name: string; usdc: string }>;

export const SUPPORTED_CHAIN_IDS = [84532, 8453] as const;
export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number];

export function selectChain(id: number): Chain {
  switch (id) {
    case 84532:
      return baseSepolia;
    case 8453:
      return base;
    default:
      throw new Error(`Unsupported chain id: ${id}`);
  }
}

export function getUsdcForChain(id: number): string {
  const entry = NETWORKS[String(id)];
  if (!entry) throw new Error(`Chain ${id} not in canonical shared/base-networks.json`);
  return entry.usdc;
}

export function getConfiguredChainId(): SupportedChainId {
  const raw = import.meta.env.VITE_BASE_CHAIN_ID;
  const n = Number(raw);
  if (n !== 84532 && n !== 8453) {
    throw new Error(`VITE_BASE_CHAIN_ID must be 84532 or 8453, got "${raw}"`);
  }
  return n;
}
